















import { Component, Mixins } from 'vue-property-decorator'
import RecommendItem from './mixins/RecommendItem'

@Component
export default class AdvertiseItem3 extends Mixins(RecommendItem) {
  url: any = false

  get goDetailExposure() {
    const { linkUrl, title } = this.value
    return `200026||${JSON.stringify({ name: title, link: linkUrl, tabname: this.tab.tabName })}`
  }
  async goDetail() {
    const { linkUrl, title } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200026', positionParam: { name: title, link: linkUrl, tabname: this.tab.tabName } })
  }

  // get linkUrl() {
  //   return this.kwtarget(this.value.linkUrl)
  // }
}
